import { Navigation } from "./Navigation/Navigation.js";
import { Dots } from "./Dots/Dots.js";
import { Sync } from "./Sync/Sync.js";

export const Plugins = { Navigation, Dots, Sync };
